import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { style: {"width":"100%","height":"100%","box-sizing":"border-box"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addressTable, (table, ti) => {
      return (_openBlock(), _createElementBlock("div", { key: ti }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.rows, (row, ri) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "d-flex",
            key: ri
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.columns, (col, ci) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "d-flex align-center",
                key: ri + '-' + ci,
                style: _normalizeStyle(_ctx.getStyle(col))
              }, [
                (col.title)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(col.title), 1)
                    ], 64))
                  : (col.key && _ctx.isLoaded)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 1,
                        "no-gutters": "",
                        class: "pt-2"
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.fieldsChild[_ctx.colKey + col.key])
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.colKey + col.key) + " ", 1),
                                  _createVNode(_component_v_progress_circular, {
                                    indeterminate: "",
                                    color: "primary",
                                    size: "20"
                                  })
                                ]),
                                _: 2
                              }, 1024))
                            : (_ctx.isSelector(col.key))
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 1,
                                  cols: "12"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select_filled, {
                                      disabled: _ctx.isSent || _ctx.readOnly,
                                      modelValue: _ctx.fieldsChild_[_ctx.colKey + col.key].value,
                                      "onUpdate:modelValue": [
                                        ($event: any) => ((_ctx.fieldsChild_[_ctx.colKey + col.key].value) = $event),
                                        _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateSpecManager()))
                                      ],
                                      items: _ctx.getSelectorValuesFile(col.key),
                                      label: col.label,
                                      "background-color": "#FFF",
                                      "hide-details": "",
                                      class: _normalizeClass({
                                        'form-field': true,
                                        'focus-form-field': _ctx.isImpactedByRule(col.key),
                                    }),
                                      clearable: "",
                                      block: "",
                                      onClick: ($event: any) => (_ctx.setFocusedField(col.key)),
                                      density: "compact",
                                      "item-title": "text",
                                      "item-value": "value"
                                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "items", "label", "class", "onClick"])
                                  ]),
                                  _: 2
                                }, 1024))
                              : (_openBlock(), _createBlock(_component_v_col, {
                                  key: 2,
                                  cols: "12"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field_filled, {
                                      disabled: _ctx.isSent || _ctx.readOnly,
                                      modelValue: _ctx.fieldsChild[_ctx.colKey + col.key].value,
                                      "onUpdate:modelValue": [
                                        ($event: any) => ((_ctx.fieldsChild[_ctx.colKey + col.key].value) = $event),
                                        _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateSpecManager()))
                                      ],
                                      "background-color": "#FFF",
                                      dense: "",
                                      label: col.label,
                                      "hide-details": "",
                                      class: _normalizeClass({
                                        'form-field': true,
                                    }),
                                      density: "compact"
                                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "label"])
                                  ]),
                                  _: 2
                                }, 1024))
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
              ], 4))
            }), 128))
          ]))
        }), 128))
      ]))
    }), 128))
  ]))
}